module.exports = function(posts) {
	'use strict'
	posts.directive('cropImageModal',cropImageModal);
	cropImageModal.$inject=['$window','getDataService','$rootScope','refreshtokenService','config','$timeout'];
	function cropImageModal($window,getDataService,$rootScope,refreshtokenService,config,$timeout) {
		return {
			restrict: 'E',
			scope: {
				currentPostObj:"=",
				crop:"="
			},
			template: require('./partial/crop-image.html'),
			link: function(scope, ele, $attrs, ctrl) {
				$rootScope.modalShow = true;
				scope.loaderImage = true;
				scope.cropthumbs = false;
				if(scope.crop =='thumbs') {
					scope.cropthumbs = true;
				} else {
					scope.cropthumbs = false;
				}
				var onResize = function() {
					console.log('resize');
					scope.$apply(function() {
						scope.currentPostObj.cancelCropModal();
					})
				}
				angular.element($window).on('resize',onResize);
				scope.cropImage = function() {
					scope.$broadcast('crop-image', {'id':scope.currentPostObj.featured_img_id});
				}
				scope.index = 0;
				scope.config = config;
				scope.thumbsArray = [];
				for(var i=config.thumbs.length-1; i>=0;i--) {
					if(config.thumbs[i].height != 0) {
						scope.thumbsArray.push(config.thumbs[i]);
					}
				}
				scope.setCropArea = function(index,width,height,url) {
					scope.selectedImage = width+' pixel x '+height+ ' pixel';
					scope.index = index;
					scope.ratioWidth = width;
					scope.ratioHeight = height;
					scope.$broadcast('set-area', {ratio:{'width':scope.ratioWidth,'height':scope.ratioHeight},'url':url});
				}
				var initCroper = $timeout(function() {
					var width = scope.thumbsArray[scope.index].width;
					var height = scope.thumbsArray[scope.index].height;
					var description = scope.thumbsArray[scope.index].description;
					var url = scope.currentPostObj.featured_img_obj.thumbs[width+'x'+height];
					scope.setCropArea(scope.index, width, height, url);
					$timeout.cancel(initCroper);
					initCroper = null;
				},0)
				scope.$on('$destroy',function() {
					angular.element($window).off('resize',onResize);
				})
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/edit-newpost/js/directive/cropImageDirective.js
// module id = 555
// module chunks = 0